import React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import { ExternalLink } from "components/common";
const StyledOl = styled.ol(
  ({ theme }) => css`
    padding-left: 20px;

    > li {
      margin-bottom: ${theme.spacings.sm};
    }

    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const GCSSetupInfo = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement("p", null, t("gcs_setup_info.intro")), /* @__PURE__ */ React.createElement(StyledOl, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcs_setup_info.step_bucket",
      components: {
        bucketsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/storage/docs/creating-buckets" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcs_setup_info.step_service_account",
      components: {
        serviceAccountsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/iam/docs/service-account-overview" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gcs_setup_info.step_credentials",
      components: {
        adcLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cloud.google.com/docs/authentication/provide-credentials-adc#how-to" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("gcs_setup_info.step_setup_backend"))));
};
export default GCSSetupInfo;
